package com.arena_web.generated

import com.arena_web.data.dto.ClubDto

val GENERATED_SPORT_CLUBS: Map<String, List<ClubDto>> = mapOf(
  "football" to listOf(
    ClubDto(
      id="15a7a81e-5bad-4bd6-9ee7-3cb2b9006f86", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bajada Padel Club", address="Tyniecka 215, 30-381 Kraków",
      city="Krakow", country="PL",
      latitude=50.0243957, longitude=19.8373337,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8273a494-55d9-4ae4-bce5-d8b7afa59640_ChIJx1BRAgpd_0.jpg",
      averageRating=5.0, totalRatingsCount=74,
      createdAt="2026-08-30T21:29:32.002732Z", updatedAt="2026-09-01T14:31:46.524617Z",
    ),
    ClubDto(
      id="a9e30fc2-551d-4f1d-9ea1-0e27b42f8af4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Walks Krakow", address="Rynek Główny 4, 33-332 Kraków",
      city="Krakow", country="PL",
      latitude=50.0613712, longitude=19.9386619,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4690c8a7-64f0-4c01-9e8f-15f09b444180_ChIJB2Qi97Nb_0.jpg",
      averageRating=5.0, totalRatingsCount=1778,
      createdAt="2026-08-30T21:28:00.075141Z", updatedAt="2026-08-30T21:56:06.249863Z",
    ),
    ClubDto(
      id="d41d8b65-c51b-4fc7-a8f6-b7b779313fd8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="«ДЮСШ «Футбольна академія Тернопіль» ТМР", address="вулиця Торговиця, 11б, Тернопіль, 46000 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.543712, longitude=25.5902961,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a495d5f8-4c73-478d-adae-a650d2b4a43b_ChIJY8nJWAA3_0.jpg",
      averageRating=5.0, totalRatingsCount=108,
      createdAt="2026-08-30T17:23:22.220276Z", updatedAt="2026-08-30T20:52:25.910535Z",
    ),
    ClubDto(
      id="4ea4e17b-eac1-4671-9d77-2987b7424f15", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Футбольна Академія Тернопіль", address="вулиця Текстильна, 18, Тернопіль, 46002 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5645115, longitude=25.6147821,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cf1e883d-e475-48ad-987f-e11ce72f94fa_ChIJb9pinOgx_0.jpg",
      averageRating=5.0, totalRatingsCount=59,
      createdAt="2026-08-30T17:23:30.362352Z", updatedAt="2026-08-30T20:52:53.548461Z",
    ),
    ClubDto(
      id="53ecefa8-54fc-4ecd-b0e4-5dc83b52b755", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AICOSPORTS PARK - FUTBOL OKULU", address="Şafak, 4540/1 Sokak No:6, 07220 Kepez/Antalya",
      city="Antalya", country="TR",
      latitude=36.9136605, longitude=30.6325108,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8196771f-ca42-4aa3-965c-ba20023d72e1_photo.jpg",
      averageRating=4.9, totalRatingsCount=303,
      createdAt="2026-08-31T23:56:07.261276Z", updatedAt="2026-08-31T23:56:07.261276Z",
    ),
    ClubDto(
      id="6c3645e7-4ba2-4df8-bc1c-be82a8518144", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GDYNIA PADEL CLUB", address="Ludwika Zamenhofa 17, 81-218 Gdynia",
      city="Gdansk", country="PL",
      latitude=54.5359897, longitude=18.4834839,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0cde514-c63b-432e-a156-03e170f6b0b7_photo.jpg",
      averageRating=4.9, totalRatingsCount=148,
      createdAt="2026-08-31T23:32:22.571650Z", updatedAt="2026-09-01T14:31:41.508437Z",
    ),
    ClubDto(
      id="1724f351-aafd-4a98-9dd6-bee51b22683d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Houston Soccer Field", address="18850 FM 529, Cypress, TX 77433",
      city="Houston", country="US",
      latitude=29.8801358, longitude=-95.6977142,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7c9bb320-4be3-418a-8f91-c27b6581f19e_photo.jpg",
      averageRating=4.9, totalRatingsCount=393,
      createdAt="2026-09-20T19:27:25.527036Z", updatedAt="2026-09-20T19:27:25.527036Z",
    ),
    ClubDto(
      id="9f6dd420-3f76-4c2a-b239-19de115e25c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Little Kickers Cyprus", address="Kyrenias 200, Aglantzia, Lefkosia 2112",
      city="Nicosia", country="CY",
      latitude=35.1486431, longitude=33.3755274,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5e712fc-613c-47f5-8291-a0aa9cfa276e_photo.jpg",
      averageRating=4.9, totalRatingsCount=59,
      createdAt="2026-09-01T09:07:36.416020Z", updatedAt="2026-09-01T09:07:36.416020Z",
    ),
    ClubDto(
      id="4a78303c-312d-4397-8479-fb4de6d58dac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rent A Field - Indoor Soccer", address="16601 NE 15th Ave, North Miami Beach, FL 33162",
      city="Miami", country="US",
      latitude=25.928734, longitude=-80.169015,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/baf33119-6f59-489a-b729-667004e4b3fe_photo.jpg",
      averageRating=4.9, totalRatingsCount=224,
      createdAt="2026-09-20T19:27:17.072432Z", updatedAt="2026-09-20T19:27:17.072432Z",
    ),
    ClubDto(
      id="feb45bd4-a8fb-4eaf-abce-5319be8b565a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccer 5 Miami – Tropical Park", address="7900 SW 40th St, Miami, FL 33155",
      city="Miami", country="US",
      latitude=25.729872, longitude=-80.324274,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2db10191-4727-4435-b05a-4bf6c3e57bb6_photo.jpg",
      averageRating=4.9, totalRatingsCount=320,
      createdAt="2026-09-20T19:27:13.769951Z", updatedAt="2026-09-20T19:27:13.769951Z",
    ),
    ClubDto(
      id="f20d7782-958e-42af-9868-620d8d712007", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sofive Soccer Centers Covina", address="699 S Barranca Ave, Covina, CA 91723",
      city="Los Angeles", country="US",
      latitude=34.077669, longitude=-117.8817225,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3df0f0c7-fadb-498c-bb7d-3dba24e66895_photo.jpg",
      averageRating=4.9, totalRatingsCount=723,
      createdAt="2026-09-20T19:10:50.283505Z", updatedAt="2026-09-20T19:10:50.283505Z",
    ),
    ClubDto(
      id="ab61cc4d-1f24-4e74-84fe-7c8a4bd599c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baza Sportivă Gheorgheni", address="Strada Mareșal Constantin Prezan, 400416 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7700626, longitude=23.6360361,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5dcaa26-853f-4f43-9eea-43b6217a815f_ChIJ6XB0M2gM_0.jpg",
      averageRating=4.8, totalRatingsCount=6068,
      createdAt="2026-08-30T22:53:43.797454Z", updatedAt="2026-09-01T14:31:47.008299Z",
    ),
    ClubDto(
      id="7fccc72b-ca31-4c6d-971b-0475409a35e6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrum Piłkarskie Ślęza Wrocław - Kłokoczyce", address="Kłokoczycka 5, 51-376 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1521712, longitude=17.1127822,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a2bf3514-fbc5-48bb-9f23-00064ace7a43_ChIJJ4jGn_bp_0.jpg",
      averageRating=4.8, totalRatingsCount=669,
      createdAt="2026-08-30T21:30:14.710356Z", updatedAt="2026-09-01T14:31:58.364990Z",
    ),
    ClubDto(
      id="656e4137-9b36-4e93-a9ce-676b4b0aebe7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kompleksi Sportiv Arena", address="Rruga Gani Toptani 9, Tiranë",
      city="Tirana", country="AL",
      latitude=41.3353612, longitude=19.7671841,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/33eb0e4e-628e-469c-bfa3-5f61dfaea72a_photo.jpg",
      averageRating=4.8, totalRatingsCount=77,
      createdAt="2026-09-01T09:16:31.852273Z", updatedAt="2026-09-01T09:16:31.852273Z",
    ),
    ClubDto(
      id="0d928ad1-30aa-4d37-847a-0fb5e7545449", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Odeco Padel Cubierto Armilla, Churriana y Granada", address="C. Habana, 103, 18194 Churriana de la Vega, Granada",
      city="Granada", country="ES",
      latitude=37.1476173, longitude=-3.6304945,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/506f855e-9ff9-47da-a159-dd1a41a1cdbc_photo.jpg",
      averageRating=4.8, totalRatingsCount=85,
      createdAt="2026-09-01T08:59:02.967012Z", updatedAt="2026-09-16T07:55:22.643501Z",
    ),
    ClubDto(
      id="7015813d-4e51-497f-9e04-e450bf369c09", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PLAYERSHOME 2", address="Transformatorweg 35, 1014 AJ Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3906437, longitude=4.8516488,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fab0c441-d0a5-4070-a1c9-0d2bb5d63018_ChIJdQiz11zj_0.jpg",
      averageRating=4.8, totalRatingsCount=174,
      createdAt="2026-08-30T21:32:42.035813Z", updatedAt="2026-08-30T21:58:53.519622Z",
    ),
    ClubDto(
      id="b79ee782-478d-479d-a679-7fffad0a47e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="R Sport Centar", address="71000, Patriotske lige 52, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8760345, longitude=18.4122806,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/29673268-4e62-4b8f-9c5e-4ecffabad32f_photo.jpg",
      averageRating=4.8, totalRatingsCount=297,
      createdAt="2026-09-01T09:17:24.236662Z", updatedAt="2026-09-01T09:17:24.236662Z",
    ),
    ClubDto(
      id="62ab9e0c-caa1-4be5-890d-307f2693c8dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rocco B. Commisso Viola Park", address="Q85C+23, Via Pian di Ripoli, 5, 50012 Bagno a Ripoli FI",
      city="Florence", country="IT",
      latitude=43.7574507, longitude=11.3201044,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/40c2d85f-3cd5-4a4a-b0ce-a80af8eb04dd_photo.jpg",
      averageRating=4.8, totalRatingsCount=993,
      createdAt="2026-08-31T23:28:59.670287Z", updatedAt="2026-08-31T23:28:59.670287Z",
    ),
    ClubDto(
      id="3a38e063-a26a-4cc2-967c-8f3e421ae56f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SAWO GRUZ ARENA", address="al. Józefa Odrowąża 1, 91-134 Łódź",
      city="Lodz", country="PL",
      latitude=51.7925907, longitude=19.383575,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/30393382-1a51-4db2-bfcb-5ed6c7019078_photo.jpg",
      averageRating=4.8, totalRatingsCount=428,
      createdAt="2026-08-31T23:37:46.138263Z", updatedAt="2026-08-31T23:37:46.138263Z",
    ),
    ClubDto(
      id="cca24cca-b355-4cb0-9179-0d9ad7f538e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="San Germano Football & More (Calcetto e Calciotto)", address="Via Antonio Beccadelli, 75, 80125 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8262876, longitude=14.1675222,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/614038df-517c-4e5f-a07c-fd7d6e4aee10_ChIJU3M0WyoP_0.jpg",
      averageRating=4.8, totalRatingsCount=110,
      createdAt="2026-08-30T21:23:58.117429Z", updatedAt="2026-08-30T21:59:56.413578Z",
    ),
    ClubDto(
      id="a2cf8359-ecc0-4412-b0d4-bf8f0057bc01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccer Arena Köln", address="Stallagsbergweg 2, 50769 Köln-Chorweiler",
      city="Cologne", country="DE",
      latitude=51.0193876, longitude=6.919091,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e0b5f2b-3e11-4ce0-abb1-073c93ea07d7_photo.jpg",
      averageRating=4.8, totalRatingsCount=264,
      createdAt="2026-08-31T22:49:16.933929Z", updatedAt="2026-08-31T22:49:16.933929Z",
    ),
    ClubDto(
      id="a78ff138-bb39-424f-acf6-2a2823eee617", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sofive Soccer Centers Meadowlands", address="2 Palmer Terrace, Carlstadt, NJ 07072",
      city="New York", country="US",
      latitude=40.824795, longitude=-74.0682588,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c641f7ba-c2fe-444c-ac87-e9a2e9575031_photo.jpg",
      averageRating=4.8, totalRatingsCount=1952,
      createdAt="2026-09-20T19:08:51.407519Z", updatedAt="2026-09-20T19:08:51.407519Z",
    ),
    ClubDto(
      id="0b034b22-f800-48de-8907-45bd991480b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark Frankfurt", address="August-Schanz-Straße 24-26, 60433 Frankfurt am Main",
      city="Frankfurt", country="DE",
      latitude=50.1633625, longitude=8.6879363,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/860491f7-155f-4c59-967e-56fbfc39efd8_photo.jpg",
      averageRating=4.8, totalRatingsCount=386,
      createdAt="2026-08-31T22:51:52.493052Z", updatedAt="2026-09-01T14:32:01.321853Z",
    ),
    ClubDto(
      id="ea25856b-e3dc-463d-8a11-c353da831940", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортивний Комплекс Академії НФК \"УРАГАН\"", address="вулиця Пасічна, 55, Івано-Франківськ, 77450 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9361794, longitude=24.6857231,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d10cc96e-87d1-41ab-8107-a97adedf237e_ChIJkToUrv3A_0.jpg",
      averageRating=4.8, totalRatingsCount=286,
      createdAt="2026-08-30T17:20:19.399642Z", updatedAt="2026-08-30T20:52:47.964741Z",
    ),
  ),
  "tennis" to listOf(
    ClubDto(
      id="df78ebc8-fd5f-4f92-a39c-c20836771464", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bornova ES Tenis Kulübü", address="Yakaköy, Reyhan Sk. No:11 D:2, 35040 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.5102797, longitude=27.3189785,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d7c653a5-3476-47f3-9519-35648396f260_photo.jpg",
      averageRating=5.0, totalRatingsCount=181,
      createdAt="2026-08-31T23:53:38.163952Z", updatedAt="2026-08-31T23:53:38.163952Z",
    ),
    ClubDto(
      id="1be62606-7393-48ca-a6b0-7f46042c8e1f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Darrod Tennis Academy", address="C. las Margaritas, S/N, 35100 Maspalomas, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=27.7728149, longitude=-15.5474509,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5dc98571-a929-4046-ba08-413a6827abab_photo.jpg",
      averageRating=5.0, totalRatingsCount=173,
      createdAt="2026-09-01T08:55:59.731038Z", updatedAt="2026-09-01T08:55:59.731038Z",
    ),
    ClubDto(
      id="15c50735-9a63-475b-8b12-7ac102d43719", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MVTA Tennis Academy", address="Fronwaldstrasse 115, 8046 Zürich",
      city="Zurich", country="CH",
      latitude=47.4206159, longitude=8.5119667,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/68f35591-702a-4630-9ebb-c54e704ec999_ChIJJ-uUxzEL_0.jpg",
      averageRating=5.0, totalRatingsCount=94,
      createdAt="2026-08-30T23:39:36.616806Z", updatedAt="2026-08-31T08:32:42.208676Z",
    ),
    ClubDto(
      id="492f2963-7c7c-4929-902c-ebcc77d8e6aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NP Tennis Academy", address="Lotnicza 72, 54-155 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1317169, longitude=16.9595958,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d839548f-bd8f-4d1d-926a-f9893bcad861_ChIJ4xP2rzvr_0.jpg",
      averageRating=5.0, totalRatingsCount=278,
      createdAt="2026-08-30T21:32:18.783384Z", updatedAt="2026-08-30T21:58:44.373482Z",
    ),
    ClubDto(
      id="23dc2b7f-aadd-4e5e-9e29-7a6ce2d0b2ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Top Smash | Magasin Tennis, Padel, Badminton et Squash", address="Rue Voltaire 26, 1201 Genève",
      city="Geneva", country="CH",
      latitude=46.2082638, longitude=6.1362432,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6acfcb9d-3915-4962-b4ff-03fed879bdcd_ChIJ729Mpkhl_0.jpg",
      averageRating=5.0, totalRatingsCount=76,
      createdAt="2026-08-30T23:00:24.062423Z", updatedAt="2026-09-01T14:31:52.174339Z",
    ),
    ClubDto(
      id="578e991b-f1a0-4ca8-beb6-11e574d89fd9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісний клуб Cactus", address="вулиця Південно-Кільцева, 45а, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2562611, longitude=25.9703035,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f63d6870-8419-4303-b5c2-29c1dac1a451_ChIJZ-_B9KYJ_0.jpg",
      averageRating=5.0, totalRatingsCount=75,
      createdAt="2026-08-30T17:23:06.101049Z", updatedAt="2026-08-30T20:52:51.764054Z",
    ),
    ClubDto(
      id="3e79bb5c-961c-4806-bd2d-cd34bad182f4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Angora Tenis Akademisi Spor Kulübü", address="Edip Akbayram Parkı, İnönü, 1767. Sk., 06370 Yenimahalle/Ankara",
      city="Ankara", country="TR",
      latitude=39.9510241, longitude=32.7175449,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c911b7b8-3201-4dee-bf50-9be6b624bcbd_photo.jpg",
      averageRating=4.9, totalRatingsCount=157,
      createdAt="2026-08-31T23:51:01.837647Z", updatedAt="2026-08-31T23:51:01.837647Z",
    ),
    ClubDto(
      id="58787a53-ed57-438c-bbaa-fd6caa797be0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Downtown Tennis Club", address="John J. Carty Park Tennis Court #1, Brooklyn, NY 11209",
      city="New York", country="US",
      latitude=40.6127187, longitude=-74.0307185,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9554cd69-f1d1-4480-837d-316b820157e8_photo.jpg",
      averageRating=4.9, totalRatingsCount=304,
      createdAt="2026-09-20T19:09:08.130285Z", updatedAt="2026-09-20T19:09:08.130285Z",
    ),
    ClubDto(
      id="18d0e2b2-82e2-4554-b311-edbc4f625f8e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Passing Club Tennis Paris 20", address="9 Rue des Frères Flavien, 75020 Paris",
      city="Paris", country="FR",
      latitude=48.8746153, longitude=2.4125738,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f01b2270-56c5-4d9e-87c1-fb80baa8e5f2_ChIJXaMk959t_0.jpg",
      averageRating=4.9, totalRatingsCount=109,
      createdAt="2026-08-30T21:15:52.835362Z", updatedAt="2026-08-30T21:59:25.906078Z",
    ),
    ClubDto(
      id="44dda2e2-e350-4988-82c4-cf91f440c0df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pinter Tennis San Sebastian", address="Uba Bidea, 61, 20014 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3054734, longitude=-1.9522606,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd8c2223-f815-48eb-9d4e-9ff1d4951dde_photo.jpg",
      averageRating=4.9, totalRatingsCount=60,
      createdAt="2026-09-01T09:02:01.967627Z", updatedAt="2026-09-01T09:02:01.967627Z",
    ),
    ClubDto(
      id="d59d7504-4b69-47eb-abe7-7d520e24e946", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SMASH SPORTS CENTER", address="Strada Orăștiei 10, 400394 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7800731, longitude=23.6606482,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4f0e5e24-c1df-4af6-8db9-abec6447f2cc_ChIJD7N9a5AN_0.jpg",
      averageRating=4.9, totalRatingsCount=83,
      createdAt="2026-08-30T22:55:20.928495Z", updatedAt="2026-09-01T14:31:52.931153Z",
    ),
    ClubDto(
      id="750eb667-c222-4036-9dca-c555d8023381", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenis centar \"Novi Grad\"", address="Olimpijska bb, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.839288, longitude=18.34755,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/73aae55a-b28c-4b63-90e0-dc0d2d9b1070_photo.jpg",
      averageRating=4.9, totalRatingsCount=79,
      createdAt="2026-09-01T09:17:34.761213Z", updatedAt="2026-09-01T09:17:34.761213Z",
    ),
    ClubDto(
      id="235926f3-2e3d-459c-a3ff-ada4dea59fd8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club de Gerland", address="405 Av. Jean Jaurès, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.7209481, longitude=4.8277911,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18399288-b0a8-455a-8762-74aa5b8e7a84_ChIJlct1_x_p_0.jpg",
      averageRating=4.9, totalRatingsCount=71,
      createdAt="2026-08-30T21:17:48.629994Z", updatedAt="2026-08-30T22:01:26.614723Z",
    ),
    ClubDto(
      id="36e5d2ac-85ba-437f-a501-d785b67f3ef1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Top Academy", address="Strada Bucuriei 12a, MD-2001, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0391202, longitude=28.8170744,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a1a8898-2dfe-489d-a7f8-8f54b02a7fc9_photo.jpg",
      averageRating=4.9, totalRatingsCount=76,
      createdAt="2026-09-01T09:14:54.620239Z", updatedAt="2026-09-01T09:14:54.620239Z",
    ),
    ClubDto(
      id="3770b862-386e-4947-b74f-fba62df2b275", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Win Pádel Club", address="Av. da Ponte, 80, Cabral, 36215 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2165517, longitude=-8.6707575,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ddf800e-3d33-40e4-9321-5384893ff006_photo.jpg",
      averageRating=4.9, totalRatingsCount=99,
      createdAt="2026-09-01T09:00:32.451935Z", updatedAt="2026-09-01T14:31:55.717632Z",
    ),
    ClubDto(
      id="298bf651-8fb3-49ec-95a2-8db699b0a45c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mitte — dolce vita | Boutique Padel Club", address="Beerenweg 3, 22761 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5664433, longitude=9.9207232,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/115549f5-8640-4ca1-aa40-d79c5bb8a6e1_ChIJB59PTQCF_0.jpg",
      averageRating=4.9, totalRatingsCount=720,
      createdAt="2026-08-30T21:13:09.988053Z", updatedAt="2026-09-01T14:31:54.792154Z",
    ),
    ClubDto(
      id="d084081c-5fd2-41f6-ac74-b0468d4da3c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mitte — the cabrio | Boutique Padel Club", address="Wandsbeker Zollstraße 25-29, 22041 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.575325, longitude=10.0746053,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/216fc3ba-afa6-4d7c-b274-f349224c98b0_ChIJdbd-x8WL_0.jpg",
      averageRating=4.9, totalRatingsCount=506,
      createdAt="2026-08-30T21:13:17.549135Z", updatedAt="2026-09-01T14:31:54.904385Z",
    ),
    ClubDto(
      id="47f9f8e9-905e-49c5-bb99-38f40a9f03cd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ολυμπιάδα Tennis Club -Thessaloniki", address="Μαρίας Κάλλας 23, Θεσσαλονίκη 546 46",
      city="Thessaloniki", country="GR",
      latitude=40.595742, longitude=22.9499188,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cca336bb-3d99-45eb-b95d-26230d62fee0_ChIJOWCWqis5_0.jpg",
      averageRating=4.9, totalRatingsCount=323,
      createdAt="2026-08-30T23:30:51.567675Z", updatedAt="2026-08-30T23:30:51.567675Z",
    ),
    ClubDto(
      id="1a53e5bc-fc68-4f0e-bc72-da38207ae050", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="All England Lawn Tennis & Croquet Club", address="Church Rd, London SW19 5AG",
      city="London", country="GB",
      latitude=51.4335559, longitude=-0.2153267,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/80eec44a-89e4-493f-83d1-d326b48b03ea_ChIJhfRDWzQP_0.jpg",
      averageRating=4.8, totalRatingsCount=11076,
      createdAt="2026-08-30T23:14:02.579494Z", updatedAt="2026-08-30T23:14:02.579494Z",
    ),
    ClubDto(
      id="7e822e92-7078-44f1-8489-b4a24972dc84", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Antalya Lara Tenis Kulübü", address="Güzelbağ, Zeybek Sk. No 117, 07070 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.873881, longitude=30.793711,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/35358b41-ada0-4a85-ac70-04ddf124f5be_photo.jpg",
      averageRating=4.8, totalRatingsCount=148,
      createdAt="2026-08-31T23:56:31.527741Z", updatedAt="2026-08-31T23:56:31.527741Z",
    ),
    ClubDto(
      id="2f7bc33a-a717-4f23-a66f-3b737c24a50c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BULUT TENİS AKADEMİSİ KORTU", address="Yenigün, 265/8. Sk., 35240 Buca/İzmir",
      city="Izmir", country="TR",
      latitude=38.3787542, longitude=27.1601719,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbf81917-d85d-4b14-a2f3-550cb57d34bc_photo.jpg",
      averageRating=4.8, totalRatingsCount=132,
      createdAt="2026-08-31T23:53:51.580025Z", updatedAt="2026-08-31T23:53:51.580025Z",
    ),
    ClubDto(
      id="ab61cc4d-1f24-4e74-84fe-7c8a4bd599c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baza Sportivă Gheorgheni", address="Strada Mareșal Constantin Prezan, 400416 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7700626, longitude=23.6360361,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5dcaa26-853f-4f43-9eea-43b6217a815f_ChIJ6XB0M2gM_0.jpg",
      averageRating=4.8, totalRatingsCount=6068,
      createdAt="2026-08-30T22:53:43.797454Z", updatedAt="2026-09-01T14:31:47.008299Z",
    ),
    ClubDto(
      id="6dce7dc2-796c-4429-b2bd-6dca98a2b1ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Budapest Tenisz Centrum", address="Budapest, Szamos u. 2/c, 1122",
      city="Budapest", country="HU",
      latitude=47.5066014, longitude=19.0183915,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4dbbfad6-23f4-47ea-b14d-4760e433d6de_ChIJz8ZXOqLe_0.jpg",
      averageRating=4.8, totalRatingsCount=266,
      createdAt="2026-08-30T22:53:10.785303Z", updatedAt="2026-08-30T22:53:10.785303Z",
    ),
    ClubDto(
      id="5389b3e8-9dc5-43dd-94d6-349a356443ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cap Tennis Lyon", address="28 Quai Victor Augagneur, 69003 Lyon",
      city="Lyon", country="FR",
      latitude=45.757372, longitude=4.8409106,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d582aff0-5cd6-4d1f-bda1-6b8d6c344e45_ChIJ81s_RFrq_1.jpg",
      averageRating=4.8, totalRatingsCount=112,
      createdAt="2026-08-30T21:17:33.253394Z", updatedAt="2026-08-31T22:11:14.779246Z",
    ),
  ),
  "basketball" to listOf(
    ClubDto(
      id="b4dcc3d0-40ae-47a5-8d51-5e333fb97dd3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ATG Macedonia Fitness Center", address="Braka Galevi 16, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.000889, longitude=21.3741438,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/417ff800-e28d-4009-8c20-b1bc6ad344d0_photo.jpg",
      averageRating=5.0, totalRatingsCount=261,
      createdAt="2026-09-01T09:19:48.244931Z", updatedAt="2026-09-01T09:19:48.244931Z",
    ),
    ClubDto(
      id="e3946921-f304-4ac7-9200-72c3f33443dd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BIQ - Basketball im Quartier", address="Neumünsterstrasse 25, 8008 Zürich",
      city="Zurich", country="CH",
      latitude=47.3615354, longitude=8.5593645,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff0c140b-fd2f-4e9c-81aa-b1da3700099a_photo.jpg",
      averageRating=5.0, totalRatingsCount=93,
      createdAt="2026-08-31T15:53:17.492633Z", updatedAt="2026-08-31T15:53:17.492633Z",
    ),
    ClubDto(
      id="b5314f88-0838-4585-8cc0-605dd595ed84", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GRINDHOUSE - Treningi Koszykówki | Trener Przygotowania Motorycznego", address="Jutrzenki 114E/LU01, 02-231 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.1934317, longitude=20.9331513,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f2de3d13-14a1-4753-bc75-c7b51357d272_photo.jpg",
      averageRating=5.0, totalRatingsCount=130,
      createdAt="2026-08-31T14:54:38.932449Z", updatedAt="2026-08-31T14:54:38.932449Z",
    ),
    ClubDto(
      id="22f38a80-d913-4259-a583-f29387939b82", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Дитяча секція баскетбольний клуб \"STAR BASKET\"", address="вулиця Воробкевича, 19, вулиця Павла Каспрука, 2, Чернівці, Чернівецька область, 58000",
      city="Chernivtsi", country="UA",
      latitude=48.2741824, longitude=25.922372,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/244a6d02-951a-4d1e-aa45-6c5a51af962f_photo.jpg",
      averageRating=5.0, totalRatingsCount=52,
      createdAt="2026-08-31T15:56:41.527766Z", updatedAt="2026-08-31T15:56:41.527766Z",
    ),
    ClubDto(
      id="ffb3af87-3dbe-4bf2-8ab1-63c81a7888c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Дитячий баскетбольний клуб Push Team", address="вулиця Григорія Сковороди, 77, Харків, Харківська область, 61024",
      city="Kharkiv", country="UA",
      latitude=50.0053831, longitude=36.2459515,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b7818cf4-5969-4594-bac7-5b4fd767d989_photo.jpg",
      averageRating=5.0, totalRatingsCount=112,
      createdAt="2026-08-31T15:38:01.903149Z", updatedAt="2026-08-31T15:38:01.903149Z",
    ),
    ClubDto(
      id="d8314f5e-216a-44a7-846e-3e46b25377d3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ADAPT", address="14901 NE 20th Ave, North Miami, FL 33181",
      city="Miami", country="US",
      latitude=25.9134889, longitude=-80.1589014,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/419827bd-4a0f-4298-81bf-69990341ef64_photo.jpg",
      averageRating=4.9, totalRatingsCount=478,
      createdAt="2026-09-20T19:14:23.891574Z", updatedAt="2026-09-20T19:14:23.891574Z",
    ),
    ClubDto(
      id="1ab9b639-a65a-4982-ad14-2d0000c049b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Game Point Miami", address="8081 W 28th Ave, Hialeah, FL 33016",
      city="Miami", country="US",
      latitude=25.8954245, longitude=-80.3389786,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/790b7bbd-2e3a-4751-818f-dfcff4fc831e_photo.jpg",
      averageRating=4.9, totalRatingsCount=172,
      createdAt="2026-09-20T19:14:26.799353Z", updatedAt="2026-09-20T19:14:26.799353Z",
    ),
    ClubDto(
      id="de435d6b-1e8f-4b6b-9e15-5e43e48185af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hoop And Pump - Kosarkaska Hala i Teretana", address="Mije Aleksića 26, Beograd",
      city="Belgrade", country="RS",
      latitude=44.8036648, longitude=20.3336142,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8df21717-3440-43ad-b287-9765785284f4_photo.jpg",
      averageRating=4.9, totalRatingsCount=75,
      createdAt="2026-08-31T14:58:37.022147Z", updatedAt="2026-08-31T14:58:37.022147Z",
    ),
    ClubDto(
      id="ed02bb4e-44e8-4c0d-8c6f-b17218533313", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hoopston Athletics", address="6210 S Dairy Ashford Rd Ste B5, Houston, TX 77072",
      city="Houston", country="US",
      latitude=29.7124192, longitude=-95.6049328,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed04a08c-bfd5-4abf-b4f8-07831c9917eb_photo.jpg",
      averageRating=4.9, totalRatingsCount=218,
      createdAt="2026-09-20T19:16:08.877413Z", updatedAt="2026-09-20T19:16:08.877413Z",
    ),
    ClubDto(
      id="9b365237-c0ba-4b00-8be3-f4ae95df5d20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="International Basketball Academy (IBA)", address="Bulevardul Pipera 196, 077190 Voluntari",
      city="Bucharest", country="RO",
      latitude=44.5285143, longitude=26.1455194,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5447fa33-084c-46a7-9f08-22c72b2faec4_photo.jpg",
      averageRating=4.9, totalRatingsCount=79,
      createdAt="2026-08-31T15:00:47.443459Z", updatedAt="2026-08-31T15:00:47.443459Z",
    ),
    ClubDto(
      id="07a95e6b-152d-4883-9173-c96363c1669b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Комплексна дитячо-юнацька спортивна школа з футболу та інших ігрових видів спорту", address="вулиця Братів Бойчуків, 4A, Тернопіль, Тернопільська область, 46002",
      city="Ternopil", country="UA",
      latitude=49.5603672, longitude=25.6391877,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ba788362-3475-459e-9f9c-90f75accbe50_photo.jpg",
      averageRating=4.9, totalRatingsCount=54,
      createdAt="2026-08-31T15:51:55.374571Z", updatedAt="2026-08-31T22:11:25.427756Z",
    ),
    ClubDto(
      id="56251c11-3716-4822-aa26-f3acb591c360", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол Ужгород", address="Unnamed Road, Розівка, Закарпатська область, 89424",
      city="Uzhhorod", country="UA",
      latitude=48.5824754, longitude=22.2598262,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/defc4054-d05c-414b-983c-b47ed7495927_photo.jpg",
      averageRating=4.9, totalRatingsCount=63,
      createdAt="2026-08-31T16:01:54.639875Z", updatedAt="2026-08-31T22:11:26.290322Z",
    ),
    ClubDto(
      id="2f4136da-1dc4-4311-b4e6-177d82018edc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ability360 Sports & Fitness Center", address="5031 E Washington St, Phoenix, AZ 85034",
      city="Phoenix", country="US",
      latitude=33.4451355, longitude=-111.9737363,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e6b17d7-4030-4dab-abb2-a1f52f6edf7b_photo.jpg",
      averageRating=4.8, totalRatingsCount=719,
      createdAt="2026-09-20T19:19:02.398677Z", updatedAt="2026-09-20T19:19:02.398677Z",
    ),
    ClubDto(
      id="e7c9e3a3-fb55-4018-bcf2-5e4312ad180b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dallas Mavericks", address="2500 Victory Ave, Dallas, TX 75219",
      city="Dallas", country="US",
      latitude=32.7905225, longitude=-96.8110147,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71274d31-4092-4103-acc5-0fef2352f604_photo.jpg",
      averageRating=4.8, totalRatingsCount=912,
      createdAt="2026-09-20T19:16:57.153167Z", updatedAt="2026-09-20T19:16:57.153167Z",
    ),
    ClubDto(
      id="14aa9873-671f-44b5-9dea-1d2d453d2979", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hoops Factory Bordeaux", address="9 Rue Dumont d'Urville, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8789943, longitude=-0.5578631,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6377a267-475a-4d2d-99be-2aab7082fc47_photo.jpg",
      averageRating=4.8, totalRatingsCount=160,
      createdAt="2026-08-31T23:20:10.493478Z", updatedAt="2026-08-31T23:20:10.493478Z",
    ),
    ClubDto(
      id="e0eb48f9-c00c-4f7d-a6e9-fe1944b24758", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Canopée - LYONSO Basket", address="30 Rue Charles de Gaulle, 69310 Oullins-Pierre-Bénite",
      city="Lyon", country="FR",
      latitude=45.6995855, longitude=4.8181981,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/224c8054-73ce-403d-ae6c-19fedc565c83_photo.jpg",
      averageRating=4.8, totalRatingsCount=166,
      createdAt="2026-08-31T15:45:47.592266Z", updatedAt="2026-08-31T15:45:47.592266Z",
    ),
    ClubDto(
      id="c5ae7dc5-7b69-4692-a433-209ca72c8be1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Levski Sofia Sports Hall", address="в.з. Малинова долинаMladost, ul. “Donka Ushlinova“ 2, 1766 Sofia",
      city="Sofia", country="BG",
      latitude=42.6225819, longitude=23.3736227,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1bbf95f5-ce02-4e3e-b311-99e5d9751f3b_photo.jpg",
      averageRating=4.8, totalRatingsCount=312,
      createdAt="2026-08-31T15:26:38.958295Z", updatedAt="2026-08-31T15:26:38.958295Z",
    ),
    ClubDto(
      id="84368a27-88ee-4967-9e17-186bcf5c4fc0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="National Basketball Performance Centre", address="Kirkmanshulme Ln, Manchester M12 4TF",
      city="Manchester", country="GB",
      latitude=53.460041, longitude=-2.1911988,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a285fde-8e00-44de-a08d-21de0d2472b1_photo.jpg",
      averageRating=4.8, totalRatingsCount=206,
      createdAt="2026-08-31T15:30:52.206964Z", updatedAt="2026-08-31T15:30:52.206964Z",
    ),
    ClubDto(
      id="4f6d5214-1446-44b6-b9c8-4713bb4bac27", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport 365 Community", address="Kreuzberg, 10999 Berlin",
      city="Berlin", country="DE",
      latitude=52.4974932, longitude=13.4361273,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66290efd-c333-4669-9f8d-044b4a7248cd_photo.jpg",
      averageRating=4.8, totalRatingsCount=322,
      createdAt="2026-08-31T15:24:21.386860Z", updatedAt="2026-08-31T15:24:21.386860Z",
    ),
    ClubDto(
      id="5e449c02-19aa-46ea-984d-1aabf869c440", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UNI Graz sports center Rosenhain", address="Aigner-Rollett-Allee 11, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.083143, longitude=15.4503387,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b0e59f83-ba92-49c0-8942-997bcffcae50_photo.jpg",
      averageRating=4.8, totalRatingsCount=63,
      createdAt="2026-08-31T15:23:30.174290Z", updatedAt="2026-08-31T22:11:23.575265Z",
    ),
    ClubDto(
      id="8052a2b4-4802-4b15-8fa0-cab8365ace90", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Urban Sportpark Eindhoven", address="Halvemaanstraat 130, 5651 BR Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4461514, longitude=5.4390942,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e2db045f-9206-43f5-bae7-d702f764311e_photo.jpg",
      averageRating=4.8, totalRatingsCount=221,
      createdAt="2026-08-31T23:48:28.500995Z", updatedAt="2026-08-31T23:48:28.500995Z",
    ),
    ClubDto(
      id="1e4d2a00-62bd-4c3a-ba24-4e91da082012", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WOD ZONE GYM", address="вулиця Петра Могили, 28, Рівне, Рівненська область, 33000",
      city="Rivne", country="UA",
      latitude=50.6183207, longitude=26.2255944,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01886203-1366-4483-a8fa-73ff37e12217_photo.jpg",
      averageRating=4.8, totalRatingsCount=158,
      createdAt="2026-08-31T16:01:31.693077Z", updatedAt="2026-08-31T16:01:31.693077Z",
    ),
    ClubDto(
      id="8a396ab5-e191-4119-a758-33d47c802cea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Športový areál Patrónka", address="Lovinského 4653/43, 811 04 Bratislava-Staré Mesto",
      city="Bratislava", country="SK",
      latitude=48.1638906, longitude=17.0799528,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/65f64d39-865c-4bc6-9a7c-0a84fa51f193_photo.jpg",
      averageRating=4.8, totalRatingsCount=167,
      createdAt="2026-08-31T15:06:23.740445Z", updatedAt="2026-08-31T15:06:23.740445Z",
    ),
    ClubDto(
      id="4672b273-3a6f-48cc-824d-717dd5eb5bc1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Баскетбольний клуб Дніпро", address="проспект Богдана Хмельницького, 118Д, Дніпро, Дніпропетровська область, 49000",
      city="Dnipro", country="UA",
      latitude=48.4063557, longitude=35.0004844,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/635d48f2-f690-4f64-bc95-838fe4cf163b_photo.jpg",
      averageRating=4.8, totalRatingsCount=196,
      createdAt="2026-08-31T15:32:38.907528Z", updatedAt="2026-08-31T15:32:38.907528Z",
    ),
  ),
  "padel" to listOf(
    ClubDto(
      id="1259f762-0506-409c-ad22-364c254e852f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Agliana Padel Club", address="Via Giovannella, 6, 51031 Agliana PT",
      city="Florence", country="IT",
      latitude=43.9088299, longitude=10.9990539,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d131614e-cea5-4ef2-956e-3f825eb85233_photo.jpg",
      averageRating=5.0, totalRatingsCount=178,
      createdAt="2026-08-31T23:30:01.485775Z", updatedAt="2026-08-31T23:30:01.485775Z",
    ),
    ClubDto(
      id="abaf441a-6766-489a-99c7-aaff0223a950", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Api Padel", address="2bis Rue du Canal, 57970 Basse-Ham, France",
      city="Luxembourg", country="LU",
      latitude=49.3776481, longitude=6.2244132,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0281f66-6a42-435c-8c88-51cd2f4ce2b6_photo.jpg",
      averageRating=5.0, totalRatingsCount=58,
      createdAt="2026-09-01T09:05:54.218139Z", updatedAt="2026-09-01T09:05:54.218139Z",
    ),
    ClubDto(
      id="15a7a81e-5bad-4bd6-9ee7-3cb2b9006f86", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bajada Padel Club", address="Tyniecka 215, 30-381 Kraków",
      city="Krakow", country="PL",
      latitude=50.0243957, longitude=19.8373337,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8273a494-55d9-4ae4-bce5-d8b7afa59640_ChIJx1BRAgpd_0.jpg",
      averageRating=5.0, totalRatingsCount=74,
      createdAt="2026-08-30T21:29:32.002732Z", updatedAt="2026-09-01T14:31:46.524617Z",
    ),
    ClubDto(
      id="e5ff47cd-69f8-4dfe-a4e8-d209cff6648b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Conquer Padel Phoenix", address="7760 S Priest Dr Ste 108, Tempe, AZ 85284",
      city="Phoenix", country="US",
      latitude=33.3477314, longitude=-111.9652386,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e762b1f0-17b7-40b2-9283-81cb776c8b92_photo.jpg",
      averageRating=5.0, totalRatingsCount=87,
      createdAt="2026-09-20T19:18:48.085401Z", updatedAt="2026-09-20T19:18:48.085401Z",
    ),
    ClubDto(
      id="018ba7eb-2bd6-4fc8-a6f6-e6e742436fd6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lara Padel Club (Antalya)", address="Güzeloluk, 1885. Sk. No:38, 07200 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8828197, longitude=30.7749055,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a17a6d84-caf7-4d48-8cf5-ff7d57163052_photo.jpg",
      averageRating=5.0, totalRatingsCount=98,
      createdAt="2026-08-31T23:56:40.909961Z", updatedAt="2026-08-31T23:56:40.909961Z",
    ),
    ClubDto(
      id="3993052b-734c-44fc-ab01-164d673e0790", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MEGA PADEL ARENA - SARAJEVO", address="Vojvode Živojina Mišića 159, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8003514, longitude=18.3397352,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/826fe72e-5477-4501-b207-79549952f590_photo.jpg",
      averageRating=5.0, totalRatingsCount=76,
      createdAt="2026-09-01T09:17:57.072328Z", updatedAt="2026-09-01T09:17:57.072328Z",
    ),
    ClubDto(
      id="0cce0aab-7944-4dbe-aac4-7a59c4e0516a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Boston", address="220 Rustcraft Rd, Dedham, MA 02026",
      city="Boston", country="US",
      latitude=42.231809, longitude=-71.1708769,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d13b1c97-c09d-4461-844b-5816011b1683_photo.jpg",
      averageRating=5.0, totalRatingsCount=129,
      createdAt="2026-09-20T19:24:42.899193Z", updatedAt="2026-09-20T19:24:42.899193Z",
    ),
    ClubDto(
      id="ca61457d-1bc2-49e1-9885-0e11a93daded", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Center & Academy", address="Lwowska 40, 40-389 Katowice",
      city="Katowice", country="PL",
      latitude=50.2502311, longitude=19.0893664,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4f0264ff-2e64-4af9-9ef5-2508538ccbcc_photo.jpg",
      averageRating=5.0, totalRatingsCount=175,
      createdAt="2026-08-31T23:40:38.065027Z", updatedAt="2026-08-31T23:40:38.065027Z",
    ),
    ClubDto(
      id="6b7818d6-95eb-43e1-ada5-db89a16feb4d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel King Savoya", address="Budapest, Hunyadi János út 162, 1117",
      city="Budapest", country="HU",
      latitude=47.4337095, longitude=19.0439974,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb886384-a817-4e5e-9c48-40dd1e23790f_ChIJjVMOVe3n_0.jpg",
      averageRating=5.0, totalRatingsCount=114,
      createdAt="2026-08-30T22:52:49.760523Z", updatedAt="2026-08-31T08:33:46.470112Z",
    ),
    ClubDto(
      id="0f52fe8c-e7d7-41e3-8092-f822de75fd57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Padel Loft Aston", address="The Padel Loft, Aston, Car Park, 5 Holt St, Birmingham B7 4BH",
      city="Birmingham", country="GB",
      latitude=52.4880329, longitude=-1.8891754,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5958a28e-93de-48a9-b45d-88eb1f155de2_photo.jpg",
      averageRating=5.0, totalRatingsCount=180,
      createdAt="2026-08-31T23:01:30.719597Z", updatedAt="2026-08-31T23:01:30.719597Z",
    ),
    ClubDto(
      id="23dc2b7f-aadd-4e5e-9e29-7a6ce2d0b2ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Top Smash | Magasin Tennis, Padel, Badminton et Squash", address="Rue Voltaire 26, 1201 Genève",
      city="Geneva", country="CH",
      latitude=46.2082638, longitude=6.1362432,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6acfcb9d-3915-4962-b4ff-03fed879bdcd_ChIJ729Mpkhl_0.jpg",
      averageRating=5.0, totalRatingsCount=76,
      createdAt="2026-08-30T23:00:24.062423Z", updatedAt="2026-09-01T14:31:52.174339Z",
    ),
    ClubDto(
      id="36e0587d-b86e-4c8a-98c1-13115c1c3514", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topadel", address="171 Rue Carnot Premier étage, 59155 Faches-Thumesnil",
      city="Lille", country="FR",
      latitude=50.6025775, longitude=3.0676205,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c39ea052-5cce-4be1-883a-356442797603_photo.jpg",
      averageRating=5.0, totalRatingsCount=243,
      createdAt="2026-08-31T23:22:19.325647Z", updatedAt="2026-08-31T23:22:19.325647Z",
    ),
    ClubDto(
      id="c36951e1-cf92-4833-b6ac-1767fec185af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mitte – highline | Boutique Padel Club", address="Höherweg 247, 40231 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2212355, longitude=6.8247222,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/153bfe31-e72d-4f54-a676-be649b7a4b21_photo.jpg",
      averageRating=5.0, totalRatingsCount=492,
      createdAt="2026-08-31T22:56:44.846286Z", updatedAt="2026-08-31T22:56:44.846286Z",
    ),
    ClubDto(
      id="fe81df0b-6866-4862-bf20-4200e502c562", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Area Padel Club", address="Atatürk OSB, 10015. Sk. No:10 A.O.S.B, 35620 Çiğli/İzmir",
      city="Izmir", country="TR",
      latitude=38.4899769, longitude=27.0422018,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b232b1f5-476a-44e3-95ff-1b9c2b0c7ce9_photo.jpg",
      averageRating=4.9, totalRatingsCount=78,
      createdAt="2026-08-31T23:54:05.221634Z", updatedAt="2026-08-31T23:54:05.221634Z",
    ),
    ClubDto(
      id="fc0c92b1-56b0-4bc6-8545-a33098095364", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ESCAPAD – Centre d’escalade, restaurant et padel à Lille", address="100 Av. Willy Brandt 2ieme etage, 59000 Lille",
      city="Lille", country="FR",
      latitude=50.6370749, longitude=3.0726191,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7f1de987-d99c-4e4e-8a55-9226812d4b09_photo.jpg",
      averageRating=4.9, totalRatingsCount=174,
      createdAt="2026-08-31T23:22:23.797579Z", updatedAt="2026-08-31T23:22:23.797579Z",
    ),
    ClubDto(
      id="6aafffe7-9dad-477d-8978-5bf5c216ac80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Finura Padel & Gym", address="Pol. Ind. Villarosa, C. Pascal, 20, Churriana, 29004 Málaga",
      city="Malaga", country="ES",
      latitude=36.671949, longitude=-4.4695492,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50cfac6a-6c5d-4aef-96c8-f19272552a2f_photo.jpg",
      averageRating=4.9, totalRatingsCount=426,
      createdAt="2026-08-31T22:42:41.738774Z", updatedAt="2026-08-31T22:42:41.738774Z",
    ),
    ClubDto(
      id="6c3645e7-4ba2-4df8-bc1c-be82a8518144", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GDYNIA PADEL CLUB", address="Ludwika Zamenhofa 17, 81-218 Gdynia",
      city="Gdansk", country="PL",
      latitude=54.5359897, longitude=18.4834839,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0cde514-c63b-432e-a156-03e170f6b0b7_photo.jpg",
      averageRating=4.9, totalRatingsCount=148,
      createdAt="2026-08-31T23:32:22.571650Z", updatedAt="2026-09-01T14:31:41.508437Z",
    ),
    ClubDto(
      id="92f0dc0d-3e48-422d-9b07-ba9fb7e0df40", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Green Padel Club", address="Ποταμιάς 157, Germasogeia, Lemesos 4045",
      city="Limassol", country="CY",
      latitude=34.7374447, longitude=33.0848869,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e49fc7f-c141-4dee-9257-7dc5897c9319_photo.jpg",
      averageRating=4.9, totalRatingsCount=83,
      createdAt="2026-09-01T09:10:12.456809Z", updatedAt="2026-09-01T09:10:12.456809Z",
    ),
    ClubDto(
      id="872d83fa-f9aa-4d45-a92d-2f3a613cfbd1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ignite Padel Speke", address="Stirling Rd, Speke, Liverpool L24 1AR",
      city="Liverpool", country="GB",
      latitude=53.3425268, longitude=-2.86111,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a27e7980-14b1-4ed7-9d30-67a7f3ec2d65_photo.jpg",
      averageRating=4.9, totalRatingsCount=165,
      createdAt="2026-08-31T23:12:26.455721Z", updatedAt="2026-08-31T23:12:26.455721Z",
    ),
    ClubDto(
      id="971729cb-147a-4463-b279-f0f14d8865ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kraken Padel Club", address="14510 S Josey Ln Ste 216, Farmers Branch, TX 75234",
      city="Dallas", country="US",
      latitude=32.945029, longitude=-96.8894302,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a4d7382-c744-4c70-8f1d-0ab6b325eabc_photo.jpg",
      averageRating=4.9, totalRatingsCount=100,
      createdAt="2026-09-20T19:16:50.030009Z", updatedAt="2026-09-20T19:16:50.030009Z",
    ),
    ClubDto(
      id="5fbc3bc2-7dbd-4ff0-8062-db77d47aec2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le Padel", address="Clubsporium, Akat, Cumhuriyet Cd. No:4, 34335 Beşiktaş/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0871719, longitude=29.0242892,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/982ebf6b-f457-470f-a1c7-1c4c5ce4f654_ChIJhaHPzmi3_0.jpg",
      averageRating=4.9, totalRatingsCount=63,
      createdAt="2026-08-30T23:09:21.824018Z", updatedAt="2026-08-31T08:32:26.284691Z",
    ),
    ClubDto(
      id="d36f040c-0cd6-4ed2-b5ad-7ba91e1b342d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADEL ZONE", address="Lagja Marigona, Prishtina 10000",
      city="Pristina", country="XK",
      latitude=42.5780876, longitude=21.103927,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ccb507ee-933e-404f-bed3-2826de6aa814_photo.jpg",
      averageRating=4.9, totalRatingsCount=79,
      createdAt="2026-09-01T09:22:01.485974Z", updatedAt="2026-09-01T09:22:01.485974Z",
    ),
    ClubDto(
      id="a0209f25-0fcb-41d1-9f78-3b0393b5ea33", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PATO Pickleball", address="Königinstraße 34, 80802 München",
      city="Munich", country="DE",
      latitude=48.1556287, longitude=11.5890326,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d39a467a-d81d-4b38-ab74-148c7cf90ec2_ChIJw_0yF451_0.jpg",
      averageRating=4.9, totalRatingsCount=212,
      createdAt="2026-08-30T21:10:19.040445Z", updatedAt="2026-08-30T21:58:53.032275Z",
    ),
    ClubDto(
      id="1581ba30-d531-4d8a-9f12-d1fa10e454e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PINE PADEL CLUB", address="Zafer, Atatürk Cd. No:196, 35395 Buca/İzmir",
      city="Izmir", country="TR",
      latitude=38.3647488, longitude=27.2165369,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/280c6570-b8f5-4d28-9b71-d118f965f7e1_photo.jpg",
      averageRating=4.9, totalRatingsCount=91,
      createdAt="2026-08-31T23:53:56.589918Z", updatedAt="2026-08-31T23:53:56.589918Z",
    ),
  ),
  "volleyball" to listOf(
    ClubDto(
      id="087b51b9-053e-4bcc-8bbc-9cd6369dfbec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus Beachvolley Club", address="Vesterengvej 35, 8200 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1824559, longitude=10.1831926,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c2ba458-c0bd-40d0-b422-c8e99c5e3a64_photo.jpg",
      averageRating=5.0, totalRatingsCount=53,
      createdAt="2026-09-01T00:09:55.112660Z", updatedAt="2026-09-01T00:09:55.112660Z",
    ),
    ClubDto(
      id="064d15f5-e2b2-42fc-ac73-977cad64988f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Athens Beach Center", address="Mpichaki 33, Ag. Ioannis Rentis 182 33",
      city="Athens", country="GR",
      latitude=37.9662783, longitude=23.6749256,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b09737fb-9e0a-4fd5-a21e-85e54c294271_photo.jpg",
      averageRating=5.0, totalRatingsCount=70,
      createdAt="2026-08-31T15:50:19.111469Z", updatedAt="2026-08-31T15:50:19.111469Z",
    ),
    ClubDto(
      id="c0982682-6acd-4315-8e57-8b3c91e6fe8f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volley Vibes", address="88 All. Jean Jaurès, 31000 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6088223, longitude=1.4540513,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7c4057bd-59b1-47b4-9a43-b797421f956f_photo.jpg",
      averageRating=5.0, totalRatingsCount=50,
      createdAt="2026-08-31T23:15:34.585624Z", updatedAt="2026-08-31T23:15:34.585624Z",
    ),
    ClubDto(
      id="669942b3-19cc-448a-a9a1-9cb466d60e97", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club BeachVolley Balear", address="Passeig Mar, 07181 Palmanova, Illes Balears",
      city="Palma", country="ES",
      latitude=39.520716, longitude=2.5374053,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/161ba0bb-cc21-468e-9fe4-27b4dbb846b7_photo.jpg",
      averageRating=5.0, totalRatingsCount=77,
      createdAt="2026-09-01T08:54:36.203304Z", updatedAt="2026-09-01T08:54:36.203304Z",
    ),
    ClubDto(
      id="fdb0f303-f31a-4bc2-b31e-dfa8139ef050", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo NZA Beach Volley Academy CTEIB", address="Carrer Gremi de Forners, 4, Nord, 07009 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.6085973, longitude=2.6645885,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18207650-3e75-4f21-b1ab-e4ca77d4870b_photo.jpg",
      averageRating=5.0, totalRatingsCount=54,
      createdAt="2026-09-01T08:54:26.514074Z", updatedAt="2026-09-01T08:54:26.514074Z",
    ),
    ClubDto(
      id="96b7c41f-788d-414b-bc8f-62364469edc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PlayFit Sports Club", address="Ursuline High School, The Downs, London SW20 8HF",
      city="London", country="GB",
      latitude=51.4146423, longitude=-0.2222377,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6cfd1bea-dcd7-4c8d-8ab2-027494b00b25_photo.jpg",
      averageRating=5.0, totalRatingsCount=71,
      createdAt="2026-08-31T14:57:56.144414Z", updatedAt="2026-08-31T22:11:20.695087Z",
    ),
    ClubDto(
      id="fa80f6df-481a-447a-b04f-cdf49200cf67", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="QBK Sports", address="41-20 39th St, Long Island City, NY 11104",
      city="New York", country="US",
      latitude=40.7468683, longitude=-73.9259383,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/07c5f7fe-5b81-43fc-acc0-59ef20148822_photo.jpg",
      averageRating=5.0, totalRatingsCount=1098,
      createdAt="2026-09-20T19:09:28.749658Z", updatedAt="2026-09-20T19:09:28.749658Z",
    ),
    ClubDto(
      id="280981cc-30ec-4a6a-b632-8c71f95e312b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Volleyball Academy Miami", address="801 Ocean Dr, Miami Beach, FL 33139",
      city="Miami", country="US",
      latitude=25.7778815, longitude=-80.1308468,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cf7cec84-fda7-44ac-b80e-3de1d530189b_photo.jpg",
      averageRating=5.0, totalRatingsCount=139,
      createdAt="2026-09-20T19:14:32.962080Z", updatedAt="2026-09-20T19:14:32.962080Z",
    ),
    ClubDto(
      id="014525ad-8840-4e5d-82ff-52f597d50692", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Arena Sports", address="Pol.Ind. III, Carrer dels Llanterners, 7, 46120 Alboraia, Valencia",
      city="Valencia", country="ES",
      latitude=39.50217, longitude=-0.3436,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8bce4a25-0e9f-43d1-b4bb-f00aba4b0966_photo.jpg",
      averageRating=4.9, totalRatingsCount=63,
      createdAt="2026-08-31T22:37:08.824742Z", updatedAt="2026-08-31T22:37:08.824742Z",
    ),
    ClubDto(
      id="8c8e1bc2-f4cd-46cb-bb1d-06593bc80ec5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach House - Boston", address="18 Tech Cir, Natick, MA 01760",
      city="Boston", country="US",
      latitude=42.3153705, longitude=-71.3333666,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11a0a300-fba9-4cd8-92f8-a9b5e2e0d5e1_photo.jpg",
      averageRating=4.9, totalRatingsCount=104,
      createdAt="2026-09-20T19:25:01.278330Z", updatedAt="2026-09-20T19:25:01.278330Z",
    ),
    ClubDto(
      id="d86a4baf-53c9-4c0d-999a-38658744d5f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volley Academy court Village Ρέντη", address="Thivon 228, Ag. Ioannis Rentis 182 33",
      city="Athens", country="GR",
      latitude=37.9752619, longitude=23.6685647,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1af0eca8-e277-4665-a3a8-4ff8177fda87_photo.jpg",
      averageRating=4.9, totalRatingsCount=56,
      createdAt="2026-08-31T15:50:24.731957Z", updatedAt="2026-08-31T15:50:24.731957Z",
    ),
    ClubDto(
      id="182ba575-877b-4ae4-896a-237eb46d8062", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach me Beachvolleyballcamps", address="Bogenstraße 17, 20144 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5724785, longitude=9.975525,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0190a9c9-9846-4de7-a9fc-6b26d8451e32_photo.jpg",
      averageRating=4.9, totalRatingsCount=98,
      createdAt="2026-08-31T15:10:59.992185Z", updatedAt="2026-08-31T15:10:59.992185Z",
    ),
    ClubDto(
      id="1d25ab73-d390-4940-af95-34e5f00fd1df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Chisinau Bouldering Project", address="Strada Independenței 32/2, MD-2072, Chișinău",
      city="Chisinau", country="MD",
      latitude=46.9765586, longitude=28.8601379,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be138bce-7439-4665-82cb-39f5b71b3a6e_photo.jpg",
      averageRating=4.9, totalRatingsCount=244,
      createdAt="2026-09-01T09:15:42.523964Z", updatedAt="2026-09-01T09:15:42.523964Z",
    ),
    ClubDto(
      id="1ab9b639-a65a-4982-ad14-2d0000c049b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Game Point Miami", address="8081 W 28th Ave, Hialeah, FL 33016",
      city="Miami", country="US",
      latitude=25.8954245, longitude=-80.3389786,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/790b7bbd-2e3a-4751-818f-dfcff4fc831e_photo.jpg",
      averageRating=4.9, totalRatingsCount=172,
      createdAt="2026-09-20T19:14:26.799353Z", updatedAt="2026-09-20T19:14:26.799353Z",
    ),
    ClubDto(
      id="b4235c62-d44a-4bd4-93f3-49cde8abd28d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportas", address="68 Hanbury St, London E1 5JL",
      city="London", country="GB",
      latitude=51.5200292, longitude=-0.0703168,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c55ce3e8-2701-47a9-bf69-8c6e9cff442e_photo.jpg",
      averageRating=4.9, totalRatingsCount=88,
      createdAt="2026-08-31T14:57:48.145263Z", updatedAt="2026-08-31T14:57:48.145263Z",
    ),
    ClubDto(
      id="bf77f2af-d1e3-482c-a438-2d4dce33db8a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tinklinio Akademija", address="Justiniškių g. 12, Vilnius, 05131 Vilniaus m. sav.",
      city="Vilnius", country="LT",
      latitude=54.7031976, longitude=25.2194347,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f7bb395-5b4f-4811-b7f7-cd131a776617_photo.jpg",
      averageRating=4.9, totalRatingsCount=106,
      createdAt="2026-08-31T15:12:30.314314Z", updatedAt="2026-08-31T15:12:30.314314Z",
    ),
    ClubDto(
      id="617125d6-fa78-4f08-b5db-02f73cbab0e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="СЕТ - пляжний волейбол та теніс на піску з підігрівом. Піклбол Київ", address="проспект Степана Бандери, Київ, 02000",
      city="Kyiv", country="UA",
      latitude=50.5009012, longitude=30.5482398,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1f26a87-39c3-4ff7-b65a-4261a664a818_photo.jpg",
      averageRating=4.9, totalRatingsCount=201,
      createdAt="2026-08-31T15:10:00.152882Z", updatedAt="2026-08-31T15:10:00.152882Z",
    ),
    ClubDto(
      id="2f4136da-1dc4-4311-b4e6-177d82018edc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ability360 Sports & Fitness Center", address="5031 E Washington St, Phoenix, AZ 85034",
      city="Phoenix", country="US",
      latitude=33.4451355, longitude=-111.9737363,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e6b17d7-4030-4dab-abb2-a1f52f6edf7b_photo.jpg",
      averageRating=4.8, totalRatingsCount=719,
      createdAt="2026-09-20T19:19:02.398677Z", updatedAt="2026-09-20T19:19:02.398677Z",
    ),
    ClubDto(
      id="9853c05d-4d67-4dc3-ba36-ff989be5bedf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach House Ülemiste", address="Valukoja tn 12, 11415 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4200036, longitude=24.808812,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/69601c68-375d-4f34-9bcc-770e5a7d05cf_photo.jpg",
      averageRating=4.8, totalRatingsCount=192,
      createdAt="2026-08-31T15:19:45.953666Z", updatedAt="2026-08-31T15:19:45.953666Z",
    ),
    ClubDto(
      id="c1c3024d-bc52-4542-8fbd-1c1127bcd874", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach volleyball court IGS Holweide", address="Burgwiesenstraße 125, 51067 Köln-Mülheim",
      city="Cologne", country="DE",
      latitude=50.9613475, longitude=7.0378338,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd796158-0b94-4d6c-af98-77db421f3806_photo.jpg",
      averageRating=4.8, totalRatingsCount=102,
      createdAt="2026-08-31T22:50:12.913329Z", updatedAt="2026-08-31T22:50:12.913329Z",
    ),
    ClubDto(
      id="098d1572-3866-4ac5-abb8-a6f4cea01951", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BeachL e.V. - Beachhalle & Beachvolleyball Außenanlage Sunlight", address="Carl-Weichelt-Straße 5, 04249 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.2973339, longitude=12.3186507,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b162606-7271-4adc-843d-48afbf293c40_photo.jpg",
      averageRating=4.8, totalRatingsCount=78,
      createdAt="2026-08-31T22:59:31.024078Z", updatedAt="2026-08-31T22:59:31.024078Z",
    ),
    ClubDto(
      id="3353b2a1-c8eb-41c0-af77-9975fcf3b507", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleyballfelder Linz", address="Saxingerstraße 8, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.305111, longitude=14.3304953,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5efc59b-b886-4874-831e-985fd01d7cea_photo.jpg",
      averageRating=4.8, totalRatingsCount=54,
      createdAt="2026-09-01T00:02:19.790342Z", updatedAt="2026-09-01T00:02:19.790342Z",
    ),
    ClubDto(
      id="ac8f531f-6f7b-4ed7-8d9d-0d45d56e330b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Budapest Beach Aréna", address="Budapest, Kőér u 2b, 1103",
      city="Budapest", country="HU",
      latitude=47.4681534, longitude=19.1298907,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9939380d-3320-41a5-b010-5fa079214c25_photo.png",
      averageRating=4.8, totalRatingsCount=52,
      createdAt="2026-08-31T15:08:48.984262Z", updatedAt="2026-08-31T15:08:48.984262Z",
    ),
    ClubDto(
      id="af52eb3e-6a9f-4a55-b7d3-ea0ec8a19b65", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Voley Playa Muchavista", address="Av. Jaime I el Conquistador, 43, 03560 El Campello, Alicante",
      city="Alicante", country="ES",
      latitude=38.384868, longitude=-0.408818,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f3f7090-6044-43fa-a0ea-2d71824b099b_photo.jpg",
      averageRating=4.8, totalRatingsCount=189,
      createdAt="2026-09-01T08:50:28.727643Z", updatedAt="2026-09-01T08:50:28.727643Z",
    ),
  ),
)
